import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './component.module.scss';
import or from "../../../../assets/coupe_or.png";
import argent from "../../../../assets/coupe_argent.png";
import cible from "../../../../assets/cible.png";

interface Manche {
  set: number;
  points: number;
}

interface RankingRow {
  user_id: string;
  login: string;
  firstname: string;
  lastname: string;
  total_points: number;
  total_kills: number;
  total_win_main: number;
  total_win_side: number;
  manches: Manche[];
}

interface RankingResponse {
  count: number;
  sets: number[];
  list: RankingRow[];
}

export function ClassementComponent({ league = "thursday" }: { league?: string } = {}) {
  const [rank, setRank] = useState<RankingRow[]>([]);
  const [sets, setSets] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    axios.get<RankingResponse>('https://labuzifpokerclub.fr/back/api/ranking/list.php', {
      params: { league },
    })
      .then((response) => {
        setRank(response.data.list ?? []);
        setSets(response.data.sets ?? []);
        setError(null);
      })
      .catch((err) => {
        console.log(err);
        setRank([]);
        setSets([]);
        setError("Impossible de charger le classement");
      })
      .finally(() => setLoading(false));
  }, [league]);

  if (loading) {
    return <p className={styles.text1}>Chargement du classement…</p>;
  }

  if (error) {
    return <p className={styles.text1}>{error}</p>;
  }

  if (rank.length === 0) {
    return <p className={styles.text1}>Aucun classement disponible</p>;
  }

  const thRanking = sets.map((s) => (
    <th key={s} className={styles.thRanking}>M {s}</th>
  ));
  const maxKills = Math.max(...rank.map((r) => r.total_kills));

  function winner(main: number,or: any, side: number, argent: any): any {
    let coupe: any[]= [];
    for (let i = 0; i < main; i++) {
        coupe.push(<img src={or} alt='winner' title='Main +5000' width={15} />);
    }

    for (let i = 0; i < side; i++) {
      coupe.push(<img src={argent} alt='winner' title='Side +2500' width={15} />);
    }
    return coupe;
  }

  return (
    <>
      <h1 className={styles.title1}>Classement</h1>

      <div className={styles.containerRanking}>
        <div className={styles.colFixed}>
          <table className={styles.tableRanking}>
            <thead className={styles.theadRanking}>
              <tr className={styles.trtheadRanking}>
                <th className={styles.thRanking}>#</th>
                <th className={styles.thRanking}>Pseudo</th>
                <th className={styles.thRanking}>Winners</th>
                <th className={styles.thRanking}>Total</th>
                <th className={styles.thRanking}>Kills</th>
              </tr>
            </thead>
            <tbody className={styles.tbodyRanking}>
              {rank.map((r, i) => (
                <tr key={r.user_id} className={styles.trtbodyRanking}>
                  <td className={styles.tdRanking}>{i + 1}</td>
                  <td className={`${styles.tdRanking} ${styles.left}`}>{r.login}</td>
                  <td className={styles.tdRanking}>{winner(r.total_win_main,or,r.total_win_side,argent)}</td>
                  <td className={styles.tdRanking}>{r.total_points}</td>
                  <td className={styles.tdRanking}>
                    {r.total_kills}
                    {r.total_kills === maxKills && <img src={cible} alt="Meilleur killer" title="Meilleur killer" width={20} />}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={styles.colOverflow}>
          <table className={styles.tableRanking}>
            <thead className={styles.theadRanking}>
              <tr className={styles.trtheadRanking}>{thRanking}</tr>
            </thead>
            <tbody className={styles.tbodyRanking}>
              {rank.map((r) => (
                <tr key={r.user_id} className={styles.trtbodyRanking}>
                  {r.manches.map((m) => (
                    <td key={m.set} className={styles.tdRanking}>{m.points}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.legend}>
        <p><img src={or} alt='Main' title='Main' width={15} /> Winner Main</p>
        <p><img src={argent} alt='Side' title='Side' width={15} /> Winner Side</p>
        <p><img src={cible} alt='Killer' title='Killer' width={20} /> Best Killer</p>
      </div>
      <div className={styles.legendPoint}>
        <p>Main 2 Points par rang gagné, Side 1pts</p>
        <p>1 points par kill, bounty 2pts</p>
        <p>Bonification Main: +20pts, +17pts, +15pts, +14pts, +13pts, +12pts, +11pts, +10pts</p>
        <p>Bonification Side: +7pts, +4pts, +2pts, +1pts</p>
      </div>
    </>
  );
}
